/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_13Inputs */

const es_chat_suggestions_welcome_13 = /** @type {(inputs: Chat_Suggestions_Welcome_13Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hola ${i?.name}. Estoy disponible para ayudarte.`)
};

const en_chat_suggestions_welcome_13 = /** @type {(inputs: Chat_Suggestions_Welcome_13Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hello ${i?.name}. I'm available to assist you.`)
};

/**
* | output |
* | --- |
* | "Hello {name}. I'm available to assist you." |
*
* @param {Chat_Suggestions_Welcome_13Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_13 = /** @type {((inputs: Chat_Suggestions_Welcome_13Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_13Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_13(inputs)
	return en_chat_suggestions_welcome_13(inputs)
});
export { chat_suggestions_welcome_13 as "chat.suggestions.welcome_13" }